// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-actions[data-v-a36deb12]{margin-left:10px}.wid[data-v-a36deb12]{width:15%}", ""]);
// Exports
module.exports = exports;
